import { makeStyles } from "@material-ui/core/styles";

import { useIsAr } from "../../../Hooks";

export default makeStyles((theme) => {
  const { isAr } = useIsAr(theme.direction);

  return {
    pageContainer: {
      display: "flex",
      gap: "32px",
      flexDirection: "column",
    },
    viewModeSwitcher: {
      display: "flex",
      flexDirection: "row-reverse",
    },
    owner: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
    },
    avatarStyle: {
      width: "32px",
      height: "32px",
      fontSize: "14px",
      fontWeight: 600,
      color: theme.palette.text.text_quarterary,
      background: theme.palette.background.secondary_hover,
    },
    containerItemAvatar: {
      border: `1px solid ${theme.palette.border.alpha_black_10}`,
      borderRadius: "50%",
    },

    //////////////////////////////////////
    // check the classes !!

    showMoreloadingSpinnerContainer: {
      width: "fit-content",
      height: "fit-content",
    },
    contactShowMoreSpinnerSection: {
      position: "relative",
      width: "86.49px",
      height: "104px",
      margin: "12px auto",
    },
    gridContainer: {
      display: "flex",
      flex: "1 1 100%",
      flexWrap: "wrap",
      gap: "20px",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        justifyContent: "center",
      },
    },
    progressWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      "& div": {
        width: "100px",
        display: "flex",
      },

      "& label": {
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    row: {
      height: 100,
    },
    badgeSection: {
      display: "flex",
      gap: "6px",
    },
    socialLinks: {
      height: "28px",
    },
    dateText: {
      display: "flex",
      flexDirection: "column",

      "& label": {
        lineHeight: "20px",
        fontWeight: 500,
      },

      "& span": {
        lineHeight: "20px",
        fontWeight: 400,
        color: theme.palette.text.tertiary,
      },
    },
    flexCol: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",

      "& span": {
        lineHeight: "24px",
        fontSize: "16px",
        fontWeight: 500,
        color: theme.palette.text.primary,
      },
    },
    //
    defaultAvatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "40px",
      width: "40px",

      "& img": {
        height: "24px",
        width: "24px",
      },
    },
    avatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "40px",
      width: "40px",

      "& img": {
        objectFit: "contain",
      },
    },
    selectContainer: {
      display: "flex",

      "& .select-wrapper.MuiFormControl-root.theme-default": {
        maxWidth: "325px",
      },
    },
    container: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
    },
    detailsColumn: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
    },
    nameRow: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      cursor: "pointer",
    },
    socialLinksBox: {
      height: "28px",
    },
    nameText: (props) => ({
      lineHeight: "24px",
      fontSize: "16px",
      fontWeight: 500,
      color: props?.isDarkMode ? "#F5F5F6" : "#101828",
    }),

    // --------
    // card

    ContactCardWrapper: {
      alignItems: "center",
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.border.secondary}`,
      borderRadius: "12px",
      color: theme.palette.text.primary,
      display: "flex",
      flex: "1 0 0",
      flexDirection: "column",
      gap: "16px",
      maxWidth: "339px",
      minWidth: "339px",
      padding: "20px 16px",
      width: "339px",
      cursor: "pointer",
    },
    details: {
      alignItems: "center",
      color: theme.palette.text.tertiary,
      display: "flex",
      gap: "10px",
      justifyContent: "center",

      "& label": {
        fontWeight: 400,
        fontSize: "16px",
      },

      "& span": {
        fontWeight: 700,
        fontSize: "14px",
      },
    },
    detailsWrapper: {
      direction: "ltr",
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    avatarWrapper: {
      alignItems: "center",
      backgroundColor: "#FFF",
      borderRadius: "50%",
      boxShadow:
        "0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)",
      display: "flex",
      height: "80px",
      justifyContent: "center",
      marginLeft: "33.33%",
      position: "relative",
      width: "80px",
    },
    defaultAvatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "72px",
      width: "72px",

      "& img": {
        height: "36px",
        width: "36px",
      },
    },
    avatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "72px",
      width: "72px",
    },
    flex: {
      display: "flex",
      width: "100%",
    },
    floatingBox: {
      background: "var(--colors-gray-dark-mode-700, #333741)",
      borderRadius: "var(--radius-full, 9999px)",
      filter: "blur(2px)",
      height: "25px",
      marginLeft: "-9px",
      marginTop: "53px",
      opacity: 0.17,
      position: "absolute",
      transform: "rotate(-2.174deg)",
      width: "118px",
    },
    userTextWrapper: {
      alignSelf: "self-end",
      display: "flex",
      position: "absolute",
    },
    userText: {
      alignItems: "flex-end",
      background: theme.palette.utility.brand_500,
      borderRadius: "9999px",
      color: "var(--white, #FFF)",
      display: "flex",
      fontSize: "14px",
      fontWeight: 500,
      marginLeft: "-6px",
      padding: "5px 40px 5px 12px",
      marginBottom: "2px",
    },
    idSection: {
      alignItems: "center",
      color: theme.palette.button.tertiary_fg,
      display: "flex",
      gap: "8px",
      justifyContent: "center",

      "& label": {
        fontSize: "16px",
        fontWeight: 600,
      },
    },
    cardHeader: {
      direction: "ltr",
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
    },
    badgeSection: {
      display: "flex",
      gap: "6px",
    },
    userInfo: {
      direction: "ltr",
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      fontSize: "14px",
      gap: "4px",

      "& label": {
        fontWeight: 400,
      },

      "& span": {
        fontWeight: 500,
      },
    },
    divider: {
      backgroundColor: theme.palette.background.secondary,
      margin: "8px 0",
    },
    nameContainer: {
      alignItems: "center",
      alignSelf: "center",
      display: "flex",
      fontSize: "20px",
      height: "60px",
      gap: "6px",

      "& label": {
        cursor: "pointer",
        fontWeight: 600,
        lineHeight: "30px",
        textAlign: "center",
      },
    },
    dateContainer: {
      direction: "ltr",
      display: "flex",
      gap: "12px",

      "& label": {
        color: theme.palette.text.secondary,
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    hyphen: {
      margin: "0 5px",
    },
    psiLabel: {
      position: "absolute",
      marginTop: "-22px",
      color: theme.palette.text.brand_tertiary,
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      marginLeft: "7px",
    },
    dateText: {
      display: "flex",
      gap: "8px",

      "& label": {
        color: theme.palette.text.primary,
        fontWeight: 500,
        fontSize: "14px",
      },

      "& span": {
        color: theme.palette.text.tertiary,
        fontWeight: 400,
        fontSize: "14px",
      },
    },
    customMenuList: {
      width: "240px",
      border: `1px solid ${theme.palette.border.secondary}`,
      borderRadius: "8px !important",
      padding: "4px 6px",
      boxShadow:
        "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03) !important",
    },
    menuIcon: {
      padding: 0,

      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    option: {
      display: "flex",
      padding: "9px 10px",
      gap: "8px",
      margin: "1px 0",
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.text.secondary,

      "&:hover": {
        backgroundColor: theme.palette.button.bg_hover,
      },
    },
    active: {
      border: `1px solid ${theme.palette.border.brand}`,
    },
    flex: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
      justifyContent: "flex-end",
      marginBottom: "24px",
    },

    customSelect: {
      width: "101px",
    },
    container: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
    },
    galleryImg: {
      border: `1px solid ${theme.palette.border.secondary}`,
      width: "40px",
      height: "40px",
      borderRadius: "6px",
      backgroundSize: "cover",
      background: "no-repeat",
      backgroundPosition: "center",
    },
    detailsColumn: {
      display: "flex",
      flexDirection: "column",
    },
    nameRow: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      cursor: "pointer",
    },
    nameText: {
      lineHeight: "24px",
      fontSize: "16px",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    communityText: {
      lineHeight: "20px",
      fontSize: "14px",
      fontWeight: 500,
      margin: 0,
    },
    unitDetails: {
      display: "flex",
      gap: "8px",
      flexWrap: "wrap",
    },
    detailItem: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.text.tertiary,
    },
    tableActionsBox: {
      display: "flex",
      gap: "4px",
      width: "fit-content",
      height: "83px",
      padding: "16px",
      alignItems: "center",
      background: theme.palette.background.paper,
      boxShadow:
        "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    },
    actionsContainer: (props) => ({
      position: "fixed",
      right: isAr ? "unset" : props?.isDesktop ? "41px" : "25px",
      zIndex: 50,
    }),
    button: {
      minWidth: "fit-content",
      padding: "10px",
      borderRadius: "6px",
    },
  };
});
